import { Injectable } from '@angular/core';
import { ServiceWorkerMessage } from '@iris/common/models/service-worker-message';
import { Subject } from 'rxjs';

const SW_AUTH_URL = '/sw.js';

@Injectable({
  providedIn: 'root',
})
export class SWService {
  private readonly authSWInitSubject = new Subject<void>();
  readonly authSWInit$ = this.authSWInitSubject.asObservable();

  private readonly isSwAuthUrl = (url: string): boolean => url?.includes(SW_AUTH_URL);

  constructor() {
    const channel = new BroadcastChannel('auth-sw-channel');
    channel.addEventListener('message', () => this.authSWInitSubject.next());

    void navigator.serviceWorker?.ready.then((registration) => {
      if (this.isSwAuthUrl(registration.active?.scriptURL)) {
        if (navigator.serviceWorker.controller) {
          this.authSWInitSubject.next();
        } else {
          navigator.serviceWorker.addEventListener('controllerchange', () => {
            this.authSWInitSubject.next();
          });
        }
      }
    });
  }

  updateToken(accessToken: string): void {
    this.sendMessage({
      type: 'UPDATE_TOKEN',
      payload: accessToken,
    });
  }

  private sendMessage(message: ServiceWorkerMessage): void {
    if (navigator.serviceWorker?.controller) {
      navigator.serviceWorker.controller.postMessage(message);
      return;
    }
    const handleControllerChange = (): void => {
      navigator.serviceWorker?.controller?.postMessage(message);
    };
    navigator.serviceWorker?.addEventListener('controllerchange', handleControllerChange, { once: true });
    void navigator.serviceWorker?.ready.then(() => {
      if (navigator.serviceWorker?.controller) {
        navigator.serviceWorker.controller.postMessage(message);
      }
    }).catch(console.error);
  }
}
